import React,{useState,useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import {useDispatch } from 'react-redux';
import {useNavigate} from 'react-router-dom';
// import { NavLink } from 'react-bootstrap';
import { FaBars } from 'react-icons/fa';
import { Nav,
    NavbarContainer,
    NavbarContainer2,
    NavLogo,
    MobileIcon,
    NavMenu,
    NavItem,
    NavLinks,
    NavBtn,
    NavBtnLink, 
    NavLinksAbout} from './NavbarElements';

import SaiLogo from '../../images/SaiLogo.png'
import UserBar from '../UserBar';
import CovidBar from '../CovidBar';
import { Container } from '@material-ui/core';
// import Logo from '../../images/imageedit_13_5201923858.png'
import './Nav.css';



const Navbar = ({toggle}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [user,setUser]= useState(JSON.parse(localStorage.getItem('profile')));

    const [scrollNav,setSrollNav]= useState(false);
    const [showComponent, setShowComponent] = useState(true);
    
    const logout = ()=>{
        dispatch({type: 'LOGOUT'});
        navigate('/');
        setUser(null)
    }

    const location = useLocation();
    const changeNav = ()=>{
        if(window.scrollY >= 80){
            setSrollNav(true)
        }else{
            setSrollNav(false)
        }
    };
    useEffect(()=>{
        const token = user?.token;

        var timer =setInterval(()=>{
            setShowComponent(!showComponent)
        },60000);

        setTimeout(()=>{
            clearInterval(timer)
        },60000)

        // jwt
        
        setUser(JSON.parse(localStorage.getItem('profile')))
        window.addEventListener('scroll',changeNav);

    },[showComponent])


    
    
    
    

    return (
        < >
            <Nav
             scrollNav={scrollNav}
             loc = {location.pathname}
              >
               <NavbarContainer>
                   <NavLogo to='/'><img className='logoPic'  src={SaiLogo} alt='logo'></img>
                   
                   </NavLogo>
                   
                   <MobileIcon onClick={toggle}>
                       <FaBars />
                   </MobileIcon>
                   <NavMenu>
                       <NavItem>
                           <NavLinks to='/#home'>Home</NavLinks>
                       </NavItem>
                       <NavItem>
                           <NavLinks  to='/discover'>Rooms</NavLinks>
                           
                       </NavItem>
                       {/* <NavItem>
                           <NavLinksAbout to='/#explore'>About Us</NavLinksAbout>
                       </NavItem> */}
                       <NavItem>
                           <NavLinks  to='/amenities'>Amenities</NavLinks>
                       </NavItem>
                       <NavItem>
                           <NavLinks  to='/placestovisit/'>Places To Visit</NavLinks>
                       </NavItem>

                       <NavItem>
                           <NavLinks  to='/gallery'>Gallery</NavLinks>
                       </NavItem>
                       {/* <NavItem>
                           <NavLinks  to='/gallery'>{}</NavLinks>
                       </NavItem> */}
                       
                    
                       <div className='divisionExt'>
                       
                       {user?<NavBtn>
                           <NavBtnLink to="/admin/messages">Messages</NavBtnLink>
                           
                       </NavBtn>:null
                       }


                       {/* { user ?<UserBar elm={user.result.givenName} img={user.result.imageUrl} />: null
                       } */}
                    
                       <NavBtn>
                                <a className='ExtLink' href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/vUfApfo0KOXlrlnVf110ng/#/search'>Book Now</a>
                        </NavBtn>
                         
                        </div> 
                     
                   </NavMenu>

                       
                             
                   
               </NavbarContainer>
               {/* {
                   showComponent&&<CovidBar />
               } */}
               
               
            </Nav>
            
        </>   
        
    )
}

export default Navbar
